module.exports = __webpack_public_path__ + "img/arrow-right.9c4335fc.svg";